export enum EnumStatus3DS {
  STARTED = "Inicializando pagamento autenticado com 3DS",
  PAYMENT_INITIATED = "Pagamento iniciado autenticado com 3DS",
  CHARGE_SUCCESS = "Cobrança realizada com sucesso",
}

export enum EnumStatusPayment {
  STARTED = "Inicializando pagamento",
  CHARGE_SUCCESS = "Cobrança realizada com sucesso",
  CHARGE_DENIED = "Cobrança negada",
  PIX_PAYMENT = "Pix gerado com sucesso",
}

export const TOAST_3DS_ID = "toast.payment.threeds";
export const TOAST_3DS_AUTO_CLOSE = 3000;
